import React, { useEffect, useState } from 'react';

import Overlay from '../../shared/components/Overlay';
import RegistrationContainer from './RegistrationContainer';
import RegistrationSuccess from './RegistrationSuccess';
import { Typography } from '@mui/material';
import UserListForEmailVerification from './UserListForEmailVerification';
import useInvitation from '../hooks/useInvitation';
import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  return new URLSearchParams(useLocation().search);
};

const Invitation = () => {
  const query = useQueryParams();
  const token = query.get('token');
  const [registered, setRegistered] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string>();

  const {
    paramsLoading,
    invitation,
    paramsError,
    acceptInvitation,
    acceptLoading,
    acceptError,
    accepted
  } = useInvitation(token);

  const { email, users } = invitation || {};

  useEffect(() => {
    if (users?.length === 1) {
      setSuccessMessage('Your account has been updated.');
      acceptInvitation({ variables: { token, userkey: users[0].userkey } });
    }
  }, [users]);

  useEffect(() => {
    if (accepted) {
      setRegistered(true);
    }
  }, [accepted]);

  const handleRegistrationCompleted = () => {
    setRegistered(true);
  };

  const loading = paramsLoading || acceptLoading;
  const error = paramsError || acceptError;
  return loading ? (
    <Overlay spinner />
  ) : !token ? (
    <Typography color="error">
      Missing token. Please check your link.
    </Typography>
  ) : error || !invitation ? (
    <Typography color="error">
      {`${error}` || 'Failed to load invitation.'}
    </Typography>
  ) : users?.length > 1 ? (
    <UserListForEmailVerification
      token={token}
      email={email}
      users={invitation.users}
    />
  ) : registered ? (
    <RegistrationSuccess
      email={email}
      verificationEmailSent={false}
      successMessage={successMessage}
    />
  ) : (
    <RegistrationContainer
      invitationToken={token}
      email={email}
      onCompleted={handleRegistrationCompleted}
    />
  );
};

export default Invitation;
